<template>
<div class="toolbar-workbook-item">
    <div v-if="!toolbar.seperator" :class="`toolbar_${toolbar.code}`" 
        :ref="`toolbar_${toolbar.code}`"
    >
        <component
            :is="getToolbarType(toolbar.type)"
            :ref="`item_${toolbar.code}`"
            class=""
            :props-data="toolbar"
            :range-style="rangeStyle"
            @toolbarEvent="toolbarEvent"
        >
            
        </component>

    </div>
    
    <div class="seperator" v-if="toolbar.seperator"></div>
</div>

</template>

<script>
import {getCurrentInstance, onMounted} from 'vue';
import toolbarItemButton from './ToolbarItemButton.vue';
import toolbarItemCombobox from './ToolbarItemCombobox.vue';
import toolbarItemColorPicker from './ToolbarItemColorPicker.vue';
import toolbarItemButtonDropdown from './ToolbarItemButtonDropdown.vue';
import i18nEnum from '@/i18ns/vi/i18nEnum';

export default {
    name: 'toolbarItemWorkbook',
    components: {
        toolbarItemButton,
        toolbarItemCombobox,
        toolbarItemColorPicker,
        toolbarItemButtonDropdown
    },
    props: {
        /**
         * Đối tượng toolbar
         */
        toolbar: {
            type: Object,
            default: {}
        },
        /**
         * style của range đang focus
         */
        rangeStyle: {
            default: {},
            type: Object
        }
    },

    emits: ['toolbarEvent'],

    setup(props, {emit}) {
        const {proxy} = getCurrentInstance();

        // Lấy loại toolbar
        const  getToolbarType = (type) => {
        switch (type) {
            case i18nEnum.ToolbarItemType.Button:
                return 'toolbarItemButton';
            case i18nEnum.ToolbarItemType.Combobox:
                return 'toolbarItemCombobox';
            case i18nEnum.ToolbarItemType.ColorPicker:
                return 'toolbarItemColorPicker';
            case i18nEnum.ToolbarItemType.ButtonDropdown:
                return 'toolbarItemButtonDropdown';
            }
        }

        const toolbarEvent = (event, type, data) => {
            emit('toolbarEvent', event, type, data);
        }

        onMounted(() => {
            let toolbar = props.toolbar;
            if (toolbar.width) {
                proxy.$refs[`toolbar_${toolbar.code}`].style.width = `${toolbar.width}px`;
            }
        })

        return {
            getToolbarType,
            toolbarEvent
        }
    }
    
}
</script>

<style lang='scss'>
.toolbar-workbook-item{
    position: relative;
    .seperator{
        border-right: 1px solid #e0e0e0;
        height: 25px;
    }
}
</style>